import WebIM from '@/utils/WebIM'
import { getHistoryMsg, getAllHistory, currentTimestamp, apiBatchUpdateMsgReader } from '@/api/chat'
import store from '../index'
import { Modal, message as Message } from 'ant-design-vue'
import moment from 'moment'
import { queryAllGroupId } from '@/api/chat'
import Config from '@/config/index'
import { computed } from 'vue'
import { handleGroupMembers, isWithinLast24Hours } from '@/utils/index'
import useUpdateMsg from '@/hooks/useUpdateMsg'
import {
  setUnreadCount,
  setStoreChatMsgList,
  clearStoreChatMsgList,
  setStoreChatMsgListReadGroupId
} from '@/utils/unReadNum'

// 初始化群聊中各个角色已读状态
// const defaultReadStatus = {
//   assistant: null,
//   doctor: null,
//   doctorAssistant: null,
//   patient: null
// }

const getGroupId = async () => {
  const data = await queryAllGroupId()
  return data || []
}

const Chat = {
  state: {
    userList: {
      groupUserList: []
    },
    msgList: {
      group: {}
    },
    currentMsgs: []
  },
  mutations: {
    // 赋值给本地群聊
    setMsgList(state, groupObj) {
      state.msgList = groupObj
    },
    //删除本地存储的群聊
    async deleteMsgList(state, payload) {
      // 获取后端当前存在的群组数据
      const groupList = await getGroupId()
      if (groupList.length > 0) {
        // 最新的groupList
        if (!groupList.includes(payload)) {
          // 考虑未来接聊天室和单聊
          const name = 'group'
          delete state.msgList[name][payload]
          // 清除本地群信息
          setStoreChatMsgList(state.msgList)
        }
      } else {
        clearStoreChatMsgList(groupList)
      }
    },
    //更新用户所有消息集合
    updateUserList(state, payload) {
      const { userList, type } = payload
      state.userList[type] = userList
    },
    //更新消息撤回信息
    updateMessageStatus(state, message) {
      const { id, mid, action, readUser } = message
      const name = 'group'
      Object.keys(state.msgList[name]).forEach(user => {
        if (action == 'oneUserReadMsgs') {
          if (state.msgList[name][readUser]) {
            state.msgList[name][readUser].forEach(msg => {
              if (msg.status != 'recall') {
                msg.status = 'read'
              } else {
                msg.msgStatus = -1
              }
            })
          }
        } else if (state.msgList[name][user].length) {
          state.msgList[name][user].forEach(msg => {
            if (action === 'readMsgs' && !msg.bySelf) {
              if (msg.status != 'recall') {
                msg.status = 'read'
              } else {
                msg.msgStatus = -1
              }
            } else if (msg.mid == id || msg.mid == mid) {
              msg.status = message.status
              msg.msgStatus = message.msgStatus || 0
              if (message.msg) {
                msg.msg = message.msg
              }
            }
          })
        }
      })
    },
    //更新消息list
    updateMsgList: async (state, payload) => {
      const { chatType, chatId, msg, bySelf, type, id, newMessage } = payload
      //新增字段 newMessage true 代表是新消息接收
      if (newMessage) {
        //收到新消息判断是否有该消息群聊的工单（处理中状态），若没有此工单消息不做存储。
        const groupList = store.getters.selfGroupIDs
        if (!groupList.includes(chatId)) {
          setStoreChatMsgListReadGroupId('group', chatId, 'del', groupList)
          return
        }
      }
      // payload的消息为漫游历史消息的话，进入判断筛选出已存在msgList当中的消息，此类消息不再添加进msgList。
      if (payload.isHistory) {
        //拿到该key已经存在的消息。
        const nowKeyMsg = state.msgList[chatType][chatId]
        //开始筛选，如果payload.mid 不等于item.id则说明msgList中没有存储。
        const newHistoryMsg =
          nowKeyMsg &&
          nowKeyMsg.filter(item => {
            return item.mid != payload.mid
          })
        //重新请求历史消息第一页覆盖发送消息
        state.msgList[chatType][chatId] = newHistoryMsg
      }
      const status = 'unread'
      if (!state.msgList[chatType][chatId]) {
        state.msgList[chatType][chatId] = [
          {
            msg,
            bySelf,
            type: type || '',
            mid: id,
            status,
            ...payload
          }
        ]
      } else {
        state.msgList[chatType][chatId].push({
          msg,
          bySelf,
          type: type || '',
          mid: id,
          status,
          ...payload
        })
        state.msgList[chatType][chatId] = state.msgList[chatType][chatId].sort((a, b) => {
          return a.time - b.time
        })
      }
      state.msgList = Object.assign({}, state.msgList)
      // 处理在其他页面接受消息后刷新未读数，并在工作台显示红点
      setUnreadCount(state.msgList)
      // 存到缓存
      setStoreChatMsgList(state.msgList)
    },

    // 处理透传消息相关
    cmdMessage(state, message) {
      const { action } = message
      // 修改消息状态
      if (action === '40009') {
        // 修改消息
        const { msgNewDataList, chatType, chatId } = useUpdateMsg(message)
        if (msgNewDataList?.length) {
          state.msgList[chatType][chatId] = msgNewDataList
        }
      }
    },

    //【透传消息实现已读状态逻辑弃用】
    updateMessageReadStatus(state, payload) {
      const { chatType, chatId, readStatus } = payload
      const list = state.msgList[chatType][chatId]
      if (list) {
        list.forEach(item => {
          if (!item.bySelf) return
          item.readStatus = readStatus
        })
      }
    },
    // 更新消息已读状态【已读回执】
    updateMessageReadAck(state, payload) {
      console.log('%c====【更新消息已读状态】====', 'color: #1890ff')
      const { mid: msgId, to: groupId, from } = payload
      const name = 'group'
      const chatId = store.getters.chatId
      if (state.msgList[name][groupId] && state.msgList[name][groupId].length) {
        const targetMsg =
          state.msgList[name][groupId].find(item => {
            return item.mid === msgId
          }) || {}
        if (!targetMsg.readRoles) {
          targetMsg.readRoles = []
        }
        // 忽略医生学生账号
        const shield = from.substr(0, 1) === 'h'
        if (!targetMsg.readRoles.includes(from) && !shield && from !== chatId) {
          targetMsg.readRoles.push(from)
        }
      }
    },
    // 更新消息已读状态【REACTION】
    updateMessageReadReaction(state, payload) {
      console.log('%c====【更新消息已读状态】====', 'color: #2138ff')
      const { to: groupId, from, messageId, reactions } = payload
      const name = 'group'
      const chatId = store.getters.chatId
      const reactionslist = reactions.map(item => item.reaction)

      if (state.msgList[name][groupId] && state.msgList[name][groupId].length) {
        const targetMsg =
          state.msgList[name][groupId].find(item => {
            return item.mid === messageId
          }) || {}
        if (!targetMsg.readRoles) {
          targetMsg.readRoles = []
        }
        // 忽略医生学生账号
        const shield = from.substr(0, 1) === 'h'
        if (!targetMsg.readRoles.includes(from) && !shield) {
          targetMsg.readRoles = [...new Set(reactionslist || [])]
        }
      }
    },
    //更新当前会话消息list
    updateCurrentMsgList(state, messages) {
      state.currentMsgs = JSON.parse(JSON.stringify(messages))
    },
    //更新本地消息id
    updateMessageMid(state, message) {
      const { id, mid } = message
      const name = 'group'
      Object.keys(state.msgList[name]).forEach(user => {
        if (state.msgList[name][user].length) {
          state.msgList[name][user].forEach(msg => {
            if (msg.mid == id) {
              msg.mid = mid
            }
          })
        }
      })
    },
    //初始化某一群租的消息
    initGroupChatState(state, groupId) {
      if (state && state.msgList && state.msgList.group) {
        state.msgList.group[groupId] = []
      }
    },
    //初始化
    initChatState(state) {
      state.msgList = {
        group: {}
      }
      state.currentMsgs = []
    }
  },
  actions: {
    //获取用户加入的群组list
    onGetGroupUserList: function (context) {
      const options = {
        success: function (resp) {
          const userList = resp.data
          userList.forEach((user, index) => {
            userList[index].name = user.groupname
          })
          context.commit('updateUserList', {
            userList,
            type: 'groupUserList'
          })
        },
        error: function () {}
      }
      WebIM.conn.getGroup(options)
    },
    // 获取当前聊天对象的记录 @payload： {key, type}
    onGetCurrentChatObjMsg: function (context, payload) {
      const { id, type } = payload
      context.commit('updateCurrentMsgList', context.state.msgList[type][id])
    },
    //发送文本消息
    onSendText: function (context, payload) {
      const { chatType, chatId, message, chatToType, is_doctor_private, ext = {} } = payload
      const id = WebIM.conn.getUniqueId()
      const userId = store.getters.chatId
      const type = chatType === 'contact' ? 'singleChat' : 'groupChat'
      // eslint-disable-next-line new-cap
      const msgObj = new WebIM.message('txt', id)
      const MembersIds = handleGroupMembers(chatToType)
      msgObj.set({
        msg: message,
        to: chatId,
        chatType: type,
        from: userId,
        ext: {
          ...ext,
          em_apns_ext: {
            em_huawei_push_badge_class: 'com.naiterui.ehp.activity.LoadActivity',
            em_push_mutable_content: true
          }
        },
        success: function (oldId, newId) {
          console.log('自定义消息Id:', oldId, '环信消息Id:', newId)
          currentTimestamp()
            .then((res = {}) => {
              context.commit('updateMsgList', {
                contentsType: 'txt',
                chatType,
                chatId: chatId,
                msg: message,
                bySelf: true,
                time: res || moment().valueOf(),
                mid: newId,
                status: 'sending',
                from: userId,
                msgRecipients: MembersIds,
                is_doctor_private
              })
            })
            .catch(() => {
              context.commit('updateMsgList', {
                contentsType: 'txt',
                chatType,
                chatId: chatId,
                msg: message,
                bySelf: true,
                time: moment().valueOf(),
                mid: newId,
                status: 'sending',
                from: userId,
                msgRecipients: MembersIds,
                is_doctor_private
              })
            })
        },
        fail: function (e) {
          console.log('Send private text error', e)
          Message.error(e.reason)
        }
      })
      if (chatType === 'group') {
        msgObj.setGroup('groupchat')
      }
      msgObj.body.msgConfig = { allowGroupAck: true }
      console.log('文本', msgObj.body)
      WebIM.conn.send(msgObj.body)
    },
    //发送图片消息
    sendImgMessage: function (context, payload) {
      console.log('payload----', payload)
      const { chatType, chatId, file, callback, onSuccess, onError, chatToType, ext = {} } = payload
      const id = WebIM.conn.getUniqueId()
      let newUrl = ''
      // eslint-disable-next-line new-cap
      const msgObj = new WebIM.message('img', id)
      const userId = store.getters.chatId
      const MembersIds = handleGroupMembers(chatToType)
      msgObj.set({
        file: file,
        to: chatId,
        chatType: chatType,
        from: userId,
        ext: {
          ...ext
        },
        onFileUploadError: function (error) {
          console.log('图片上传失败', error)
          callback()
          onError && onError(error)
        },
        onFileUploadComplete: function (data) {
          newUrl = data.uri + '/' + data.entities[0].uuid
        },
        success: function (oldId, newId) {
          console.log('图片发送成功', oldId, newId)
          currentTimestamp()
            .then((res = {}) => {
              context.commit('updateMsgList', {
                contentsType: 'img',
                msg: newUrl,
                chatType,
                chatId: chatId,
                bySelf: true,
                type: 'img',
                time: res || moment().valueOf(),
                mid: newId,
                status: 'sending',
                from: userId,
                msgRecipients: MembersIds
              })
            })
            .catch(() => {
              context.commit('updateMsgList', {
                contentsType: 'img',
                msg: newUrl,
                chatType,
                chatId: chatId,
                bySelf: true,
                type: 'img',
                time: moment().valueOf(),
                mid: newId,
                status: 'sending',
                from: userId,
                msgRecipients: MembersIds
              })
            })
          callback()
          onSuccess && onSuccess(newId)
        },
        fail: function (e) {
          console.log('Send private img error', e)
          Message.error(e.reason)
          onError && onError(e)
        }
      })
      if (chatType === 'group') {
        msgObj.setGroup('groupchat')
      }
      console.log('图片', msgObj.body)
      msgObj.body.msgConfig = { allowGroupAck: true }
      WebIM.conn.send(msgObj.body)
    },

    //获取历史消息
    getHistoryMessage: function (context, payload) {
      const {
        groupid,
        pageSize = 10,
        page = 1,
        startTime = '',
        endTime = '',
        lastMsgMid = ''
      } = payload
      //如果是第一页且没有按需查询先清空数据
      if (payload.page === 1 && !lastMsgMid) {
        context.commit('initGroupChatState', groupid)
      }
      getHistoryMsg({ groupId: groupid, pageSize, page, startTime, endTime, msgId: lastMsgMid })
        .then((res = {}) => {
          const { list = [] } = res
          try {
            payload.success && payload.success(res)
            if (list.length) {
              list.forEach(
                ({
                  bodies = {},
                  timestamp,
                  to,
                  from,
                  msgId,
                  msgType,
                  msgStatus,
                  msgRecipients,
                  recallTimestamp,
                  readers,
                  extraReaders,
                  // 点赞 点踩 撤回
                  operationUsers
                }) => {
                  const msgTime = Number(timestamp)
                  const bySelf = from === store.getters.chatId

                  // 筛选读取角色
                  const readRoles = (readers || [])
                    .filter(
                      item =>
                        item.identityType !== 8 &&
                        (!bySelf || item.emUserId !== store.getters.chatId)
                    )
                    .map(item => item.emUserId)

                  // 构建基础消息结构
                  let msg = {
                    chatType: 'group',
                    chatId: payload.isGroup ? to : bySelf ? to : from,
                    bySelf,
                    time: msgTime,
                    recallTimestamp,
                    mid: msgId,
                    status: 'read',
                    msgStatus,
                    msgRecipients,
                    contentsType: bodies.type,
                    from,
                    readRoles,
                    extraReaders,
                    isHistory: true,
                    page,
                    operationUsers
                  }

                  // 根据内容类型添加消息内容
                  const contentMap = {
                    txt: () => ({ msg: bodies.msg }),
                    audio: () => ({ msg: bodies.url }),
                    video: () => ({ msg: bodies.url }),
                    img: () => ({ msg: bodies.url }),
                    custom: () => ({ msg: bodies, customEvent: msgType.toString() }),
                    file: () => ({ msg: bodies.url })
                  }

                  if (bodies.type in contentMap) {
                    msg = { ...msg, ...contentMap[bodies.type]() }
                  }

                  context.commit('updateMsgList', msg)
                }
              )
            }
            context.commit(
              'updateCurrentMsgList',
              context.state.msgList[payload.type][payload.groupid]
            )
            updateMessageReadBatch(list)
          } catch (e) {
            console.log('error', e)
          }
        })
        .catch(() => {})
      // 历史消息批量更新已读状态
      const updateMessageReadBatch = function (list) {
        const filterOptions = msgItem => {
          // 系统消息和屏蔽的消息
          const isSheiled =
            !Config.SHIELD_MSG.includes(msgItem.msgType.toString()) &&
            !Config.SYSTEM_MESSAGES.includes(msgItem.msgType.toString())
          // 不是自己发的消息
          const isSelf = msgItem.from !== store.getters.chatId
          // 发过的消息
          const isReaded = msgItem.readers
            ? msgItem.readers.some(re => {
                return re.emUserId === store.getters.chatId
              })
            : false
          // 撤回的消息
          const isRecall = msgItem.msgStatus !== -1
          // 历史消息不处理
          const notHistory = msgItem.msgRecipients && msgItem.msgRecipients.length
          return isSheiled && isSelf && !isReaded && isRecall && notHistory
        }
        const msgIdList = list.filter(filterOptions).map(item => item.msgId)
        console.log('【后端批量发送已读回执的历史消息】', msgIdList)
        msgIdList.length &&
          apiBatchUpdateMsgReader({
            msgIdList
          })
        // 环信循环已读
        const msgIn24hLists = list.filter(filterOptions).filter(item => {
          return isWithinLast24Hours(item.timestamp)
        })
        console.log('list', list)
        console.log('【环信循环发送已读回执的历史消息】', msgIn24hLists)
        if (msgIn24hLists.length) {
          msgIn24hLists.forEach(it => {
            ack(it)
          })
        }
      }
      // 发送已读回执
      const ack = function (message) {
        const dealingGroupId = computed(() => store.state.group.dealingGroupId)
        const activeTabKey = computed(() => store.state.app.tabActivekey)
        if (dealingGroupId.value === message.to && activeTabKey.value === 'Chat') {
          const bodyId = message.msgId // 需要发送已读回执的消息id
          const msg = new WebIM.message('read', WebIM.conn.getUniqueId())
          const { to, chatType } = message
          msg.set({
            id: bodyId,
            to: to,
            chatType: chatType
          })
          console.log('%c====发送已读回执====', 'color: rgb(114, 46, 209)', msg.body)
          WebIM.conn.send(msg.body)
          message.msgRecipients.includes(store.getters.chatId) &&
            WebIM.conn.addReaction({ messageId: bodyId, reaction: store.getters.chatId })
        }
      }
    },
    recallMessage: function (context, payload) {
      const { mid, chatId } = payload
      const option = {
        mid,
        to: chatId,
        type: 'groupchat',
        success: function () {
          console.log('调用环信消息撤回成功，mid：', mid, 'chatId:', chatId)
          payload.status = 'recall'
          payload.msgStatus = -1
          context.commit('updateMessageStatus', payload)
        },
        fail: function (message) {
          let title = '消息撤回失败'
          if (message.reason === 'exceed recall time limit') {
            title = '该消息超过撤回时间，不能被撤回'
          }
          Modal.warning({
            title: () => title,
            okText: () => '确定'
          })
        }
      }
      WebIM.conn.recallMessage(option)
    },
    //初始化
    initChatState: function (context, payload) {
      console.log('初始化', payload)
      context.commit('initChatState')
    },
    // 清除群聊、患者私聊、导诊、医生私聊 的本地存储的群聊
    clearAllMsg(context, groupIds = []) {
      groupIds.forEach(id => {
        id && context.commit('deleteMsgList', id)
      })
    }
  },
  getters: {
    onGetCurrentChatObjMsg(state) {
      return state.currentMsgs
    },
    fetchHistoryMessages(state) {
      return state.currentMsgs
    }
  }
}
export default Chat
